import { ArrowRight, MessageCircle } from "lucide-react";
import { getWhatsAppLink } from "../lib/config";
import { Link } from "react-router-dom";

export const CTASection = ({
  title = "Pronto a Passare all'Energia Solare?",
  subtitle = "Contattaci per una consulenza gratuita e scopri quanto puoi risparmiare",
  primaryLabel = "Scrivici su WhatsApp",
  secondaryLabel = "Form Contatti",
  secondaryTo = "/contatti",
}) => {
  return (
    <section
      data-testid="cta-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/15 via-slate-950 to-teal-500/10" />
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 50%, rgba(16, 185, 129, 0.15), transparent 40%), radial-gradient(circle at 80% 50%, rgba(20, 184, 166, 0.15), transparent 40%)",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-5 text-center">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-5 leading-[1.05]">
          {title}
        </h2>
        <p className="text-base lg:text-lg text-slate-300 max-w-2xl mx-auto mb-10">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-primary"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 text-slate-950 font-semibold hover:shadow-2xl hover:shadow-emerald-500/40 hover:scale-105 transition-all"
          >
            <MessageCircle className="w-5 h-5" />
            {primaryLabel}
          </a>
          <Link
            to={secondaryTo}
            data-testid="cta-secondary-link"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-emerald-500/40 bg-white/5 text-white font-semibold hover:bg-emerald-500/10 hover:border-emerald-400 transition-all"
          >
            {secondaryLabel}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};
